<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="dform-header d-flex justify-content-end" cdkDragHandle>
    <button *ngIf="!data?.hidenBtn" mat-icon-button (click)="onCloseCancel()">
      <mat-icon>close</mat-icon>
    </button>
    <div *ngIf="data?.hidenBtn" class="view-header"></div>
  </div>
  <div mat-dialog-content>
    <div class="d-flex justify-content-center">
      <img src="assets/images/images-status/success.png" srcset="assets/images/images-status/success@2x.png 2x,
      assets/images/images-status/success@3x.png 3x" alt="{{'lbl.no-data' | translate }}" class="img-empty">
    </div>
    <div class="dform-title">
      {{data?.title || 'Title' | translate}}
    </div>
    <!-- Error Detail -->
    <!-- <p class="text-center" *ngIf="!data?.innerHTML">{{data?.message || 'Message' | translate}}</p>
    <p class="text-center" *ngIf="data?.innerHTML" [innerHTML]="data?.innerHTML"></p> -->
    <p class="text-center" *ngIf="data?.message">{{data?.message || 'Message' | translate}}</p>
    <p class="text-center" *ngIf="data?.innerHTML" [innerHTML]="data?.innerHTML"></p>
  </div>
  <div mat-dialog-actions class="justify-content-center">
    <button class="btn btn-error btn-md" (click)="onCloseConfirm()">
      <!-- Error Button -->
      {{  data?.closeBtn ?  data?.closeBtn : 'btn.close' | translate}}
    </button>
  </div>
</div>